import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { davidsonConfig } from "./data";

export default function DavidsonPage() {
  return <CityPageTemplate config={davidsonConfig} />;
}